import { jsxs as T, jsx as s } from "react/jsx-runtime";
import { useRef as y, useCallback as E, useEffect as C, forwardRef as L } from "react";
import { V as M } from "../index-EGJl6EpT.js";
import { c as W } from "../clsx-OuTLNxxd.js";
import { B as q } from "../Button-D6KC5041.js";
import '../Dialog.css';const P = "_closeButton_1qjom_32", X = "_dialog_1qjom_36", Y = "_hasBackdrop_1qjom_50", $ = "_isFullScreen_1qjom_53", z = "_closeButtonWrapper_1qjom_62", V = "_dialogWrapper_1qjom_75", A = "_panel_1qjom_89", l = {
  closeButton: P,
  dialog: X,
  hasBackdrop: Y,
  isFullScreen: $,
  closeButtonWrapper: z,
  dialogWrapper: V,
  panel: A
}, x = ({
  children: t,
  className: r,
  hasBackdrop: n = !0,
  isFullScreen: N = !1,
  isOpen: e = !1,
  setIsOpen: i,
  shouldCloseOnClickOutside: u = !0,
  title: p,
  triggerRef: a,
  ...b
}) => {
  const c = y(null), d = E(
    (o) => {
      var k, g, j;
      if (!u)
        return;
      const w = (k = c.current) == null ? void 0 : k.getBoundingClientRect(), { bottom: m = 0, left: _ = 0, right: f = 0, top: B = 0 } = w || {};
      if (B === 0 && m === 0 && _ === 0 && f === 0)
        return;
      const D = o.clientY < B || o.clientY > m || o.clientX < _ || o.clientX > f, h = ((g = a == null ? void 0 : a.current) == null ? void 0 : g.isConnected) ?? !1, F = h && ((j = a == null ? void 0 : a.current) == null ? void 0 : j.contains(o == null ? void 0 : o.target)), S = o.target === c.current;
      e && (S || D && !F && h) && i(!1);
    },
    [e, u, i, a]
  );
  return C(() => {
    c.current && (e ? c.current.showModal() : c.current.close());
  }, [c, e]), C(() => {
    if (!(typeof window > "u"))
      return document.addEventListener("click", d), () => {
        document.removeEventListener("click", d);
      };
  }, [d]), /* @__PURE__ */ T(
    "dialog",
    {
      "aria-label": `${p}-modal`,
      className: W(
        l.dialog,
        { [l.hasBackdrop]: n },
        { [l.isFullScreen]: N },
        r
      ),
      id: "cxy-dialog",
      ref: c,
      ...b,
      children: [
        /* @__PURE__ */ s("div", { className: l.closeButtonWrapper, children: /* @__PURE__ */ s(
          q,
          {
            "aria-label": `Close ${p} Modal`,
            className: l.closeButton,
            "data-testid": "close-button",
            onClick: () => i(!1),
            variant: "ghost",
            children: /* @__PURE__ */ s(M, { size: "xl" })
          }
        ) }),
        /* @__PURE__ */ s("div", { className: l.dialogWrapper, children: t })
      ]
    }
  );
}, G = ({ children: t, className: r, ...n }) => /* @__PURE__ */ s("section", { className: W(l.panel, r), ...n, children: /* @__PURE__ */ s("div", { className: l.panelWrapper, children: t }) }), H = L(({ children: t, ...r }, n) => /* @__PURE__ */ s(q, { ref: n, variant: "ghost", ...r, children: t }));
x.Panel = G;
x.Trigger = H;
export {
  x as Dialog
};
